import { InlineNotificationData, MeterCountRetrievalType } from '../models';

export const INLINE_NOTIFICATION_CONFIG: Record<MeterCountRetrievalType, InlineNotificationData> = {
  smartMeter: {
    retrievalType: 'smartMeter',
    title: 'ummeldung.step.date.smartMeterInfoTitle',
    description: 'ummeldung.step.date.smartMeterInfoDescription',
    type: 'success',
  },
  manual: {
    retrievalType: 'manual',
    title: 'ummeldung.step.date.manualReadingInfoTitle',
    description: 'ummeldung.step.date.manualReadingInfoDescription',
    type: 'info',
  },
  missingSelection: {
    retrievalType: 'missingSelection',
    title: 'ummeldung.step.date.misssingReadingInfoTitle',
    description: 'ummeldung.step.date.misssingReadingInfoDescription',
    type: 'warning',
    linkText: 'ummeldung.step.date.backToStep1Label',
  },
};
